import { useSelector } from "common/utilities/react-redux";
import { useTrack } from "common/utilities/useTrack";
import { getCurrentMap } from "domains/createMapDetail/selectors";

export const useTrackDimensions = () => {
  const currentMap = useSelector(getCurrentMap);
  const track = useTrack();

  const data = {
    entityId: currentMap?.id,
    entityName: currentMap?.name ?? "(new map)",
    entityType: "Custom Map",
    page: "Create",
  } as const;

  return {
    trackAddDimension: (dimensionId: string) =>
      track({ ...data, name: "Add Topic to Map", secondaryEntityId: dimensionId, secondaryEntityType: "Topic" }),
    trackRemoveDimension: (dimensionId: string) =>
      track({ ...data, name: "Remove Topic from Map", secondaryEntityId: dimensionId, secondaryEntityType: "Topic" }),
    trackRemoveAllDimensions: () => track({ ...data, name: "Clear Map" }),
  };
};
